import { HelmetProvider } from '@dr.pogodin/react-helmet';

import { InceptPersistentStorageProvider } from '../../../contexts';
import { AuthProvider } from '../../../contexts/AuthContext';
import { FeaturesProvider } from '../../../contexts/features';
import { RequestsProvider } from '../../../contexts/RequestsContext';
import { ReturnUrlProvider } from '../../../contexts/ReturnUrlContext';
import { UserSubscriptions } from '../../../contexts/UserContext';
import { WebsocketProvider } from '../../../contexts/websockets';
import { ScopedUserProvider } from '../components/ScopedUserProvider';

// The user, websocket, and user-subscription providers all key off the current
// module (resolved above by ModuleScopeProvider), so they live here rather than
// per-portal. WebsocketProvider must sit below the user (connection is keyed on
// the authenticated user) and UserSubscriptions below both.
export const PROVIDER_STACK = [
  // top most provider
  ReturnUrlProvider,
  HelmetProvider,
  InceptPersistentStorageProvider,
  AuthProvider,
  RequestsProvider,
  FeaturesProvider,
  ScopedUserProvider,
  WebsocketProvider,
  UserSubscriptions,
  // inner most provider
];
